import script from "./ErrorMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&setup=true&lang=js"

import "./ErrorMessage.vue?vue&type=style&index=0&id=fe3a9e44&lang=postcss"

export default script